/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PutPaymentRequestRequestSupplier
 */
export interface PutPaymentRequestRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'accountType': PutPaymentRequestRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'companyName': string;
}

export const PutPaymentRequestRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type PutPaymentRequestRequestSupplierAccountTypeEnum = typeof PutPaymentRequestRequestSupplierAccountTypeEnum[keyof typeof PutPaymentRequestRequestSupplierAccountTypeEnum];


